// Default environment configuration (development)
export const environment = {
  production: false,
  envName: 'development',
  apiUrl: 'https://backend-certiport-test.certiports.com',  // Direct connection to local backend
  projectId: 'vps-certiport',
  region: 'europe-west1',
  features: {
    debugMode: true,
    mockData: false,
    enableAnalytics: false,
    enableErrorReporting: false
  },
  api: {
    timeout: 30000,
    retryAttempts: 3
  },
  logging: {
    level: 'debug',
    enableConsoleLog: true
  }
};
